import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActivityIndicator } from '@trinity/chat-components/components/presentation/ActivityIndicator.js';
import { useSelectHomePageLocation } from '@/store/selectors';

export const Home = () => {

  const homeRoute = useSelectHomePageLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (homeRoute) {
      navigate(homeRoute, { replace: true });
    }
  }, [homeRoute, navigate]);

  if (!homeRoute) {
    return <ActivityIndicator />;
  }

  return null;
};